export default __webpack_public_path__ + "static/media/chevronLeftWhite.2b120d56.svg";